module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("KIDNAPPED BY   THE TALIBAN ")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "txc1",
    attrs: {
      "id": "p0021-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexxi"
    }
  }, [_c('i', [_vm._v("The first time we meet, we are friends. The   next time we meet, we are   brothers.")]), _c('br'), _vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FGHAN PROVERB")])])]), _c('a', {
    attrs: {
      "id": "pagexxi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8aa57bda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forward2.vue
// module id = 78
// module chunks = 0